import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";

function TestimonialAdmin() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/index.php/Blank/list_testimonials`
        );

        if (res.data.status) {
          setTestimonials(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    const full = Math.floor(rating);
    const half = rating % 1 !== 0;

    for (let i = 0; i < full; i++) {
      stars.push(<i key={i} className="bi bi-star-fill text-warning"></i>);
    }

    if (half) {
      stars.push(<i key="half" className="bi bi-star-half text-warning"></i>);
    }

    return stars;
  };

  return (
    <div className="container-fluid my-5">
      <h2 className="text-center fw-bold text-dark mb-5">TESTIMONIAL</h2>

      <div className="testimonial-container d-flex flex-wrap justify-content-center gap-5">
        {testimonials.map((item, index) => (
          <div key={index} className="testimonial-box bg-col text-center p-4 rounded">
            <img
              src={`${BASE_URL}/${item.image}`}
              alt={item.customer_name}
              className="rounded-circle mb-3"
              style={{ width: "90px", height: "90px", objectFit: "cover" }}
            />

            {/* Stars */}
            <div className="text-warning mb-2">
              {renderStars(Number(item.rating))}
            </div>

            {/* Review */}
            <p className="text-light">
              <i className="text-light fs-4 bi bi-quote text-muted"></i>
              {item.customer_review}
              <i className="text-dark fs-4 bi bi-quote rotate-quote"></i>
            </p>

            {/* Customer Name */}
            <h5 className="fw-bold text-light mb-0">{item.customer_name}</h5>
          </div>
        ))}
      </div>

      {/* CSS */}
      <style>{`
        .testimonial-box {
          width: 350px;
          transition: all 0.3s ease;
        }
        .testimonial-box:hover {
          transform: scale(1.05);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }

        @media (min-width: 1200px) {
          .testimonial-container {
            gap: 3rem;
          }
          .testimonial-box {
            width: 360px;
          }
        }

        @media (max-width: 1199px) and (min-width: 768px) {
          .testimonial-box {
            width: 320px;
          }
          .testimonial-container {
            gap: 2rem;
          }
        }

        @media (max-width: 767px) {
          .testimonial-container {
            flex-direction: column;
            align-items: center;
          }
          .testimonial-box {
            width: 90%;
          }
        }
      `}</style>
    </div>
  );
}

export default TestimonialAdmin;
